import { PLATFORM_MODULE_KEYS } from '@/constants/services'

const SESSION_PERMISSIONS_KEY = 'permissions'
const PENDING_PERMISSIONS_KEY = 'tmp_permissions'
const SUPERADMIN_ROLE_ID = 1

export const PROFILE_MODULES_BY_MENU_KEY = {
  [PLATFORM_MODULE_KEYS.CAMPAIGNS]: ['campaigns_sms', 'campaigns_whatsapp', 'campaigns_email', 'campaigns_calls'],
  [PLATFORM_MODULE_KEYS.CAMPAIGN_REPORTS]: ['reports'],
  [PLATFORM_MODULE_KEYS.CONSUMPTION_REGISTERS]: ['reports'],
  [PLATFORM_MODULE_KEYS.WORKGROUPS]: ['contact_center'],
  [PLATFORM_MODULE_KEYS.SUPERVISOR]: ['contact_center'],
  [PLATFORM_MODULE_KEYS.CHAT]: ['contact_center'],
  [PLATFORM_MODULE_KEYS.FILES]: ['files'],
  [PLATFORM_MODULE_KEYS.SHORT_URL]: ['short_url'],
  [PLATFORM_MODULE_KEYS.AGENDAS]: ['contacts'],
  [PLATFORM_MODULE_KEYS.BLACKLIST]: ['blacklist'],
  [PLATFORM_MODULE_KEYS.USERS]: ['users']
}

export function normalizePermissions(raw) {
  if (!Array.isArray(raw)) {
    return []
  }
  return raw.filter((item) => typeof item === 'string' && item.includes('.'))
}

function readPermissions(key) {
  try {
    return normalizePermissions(JSON.parse(localStorage.getItem(key) ?? '[]'))
  } catch {
    return []
  }
}

export function getSessionPermissions() {
  return readPermissions(SESSION_PERMISSIONS_KEY)
}

export function setSessionPermissions(raw) {
  localStorage.setItem(SESSION_PERMISSIONS_KEY, JSON.stringify(normalizePermissions(raw)))
}

export function setPendingPermissions(raw) {
  localStorage.setItem(PENDING_PERMISSIONS_KEY, JSON.stringify(normalizePermissions(raw)))
}

export function promotePendingPermissions() {
  setSessionPermissions(readPermissions(PENDING_PERMISSIONS_KEY))
  localStorage.removeItem(PENDING_PERMISSIONS_KEY)
}

export function clearSessionPermissions() {
  localStorage.removeItem(SESSION_PERMISSIONS_KEY)
  localStorage.removeItem(PENDING_PERMISSIONS_KEY)
}

export function isSuperAdmin(user) {
  return Number(user?.role_id) === SUPERADMIN_ROLE_ID || Boolean(user?.isSuperAdmin)
}

export function hasAssignedProfile(user) {
  return Boolean(user?.profile_id)
}

export function hasProfilePermission(user, permissions, moduleKey, action) {
  if (!user) {
    return false
  }
  if (isSuperAdmin(user)) {
    return true
  }
  return permissions.includes(`${moduleKey}.${action}`)
}

export function canUseProfileAction(user, permissions, moduleKey, action) {
  if (!user) {
    return false
  }
  if (!hasAssignedProfile(user)) {
    return true
  }
  return hasProfilePermission(user, permissions, moduleKey, action)
}

export function canViewMenuModule(user, permissions, menuModuleKey) {
  if (!user) {
    return false
  }
  const profileModules = PROFILE_MODULES_BY_MENU_KEY[menuModuleKey]
  if (!profileModules || isSuperAdmin(user) || !hasAssignedProfile(user)) {
    return true
  }
  return profileModules.some((moduleKey) => hasProfilePermission(user, permissions, moduleKey, 'view'))
}

export function createMenuModuleVisibility(user, permissions = getSessionPermissions()) {
  return (menuModuleKey) => canViewMenuModule(user, permissions, menuModuleKey)
}
